import { defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, withModifiers as _withModifiers, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vShow as _vShow, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["placeholder"]
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 1,
  class: "no-data"
}

import { computed, onMounted, onUnmounted, ref, watch } from 'vue';

interface IProps {
  options: { label: string; value: string }[];
  modelValue: string;
  placeholder?: string;
  minWidth?: string;
  maxWidth?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    options: {},
    modelValue: {},
    placeholder: { default: '' },
    minWidth: { default: '100px' },
    maxWidth: { default: '300px' }
  },
  emits: ['update:modelValue', 'change'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const iconClass = computed(() => (!showDropdown.value ? 'arrow-down' : 'search'));
const displayValue = ref('');
const showDropdown = ref(false);
const selectRef = ref<HTMLElement | null>(null);
const inputRef = ref<HTMLInputElement | null>(null);
const isFocused = ref(false);
const isSearching = ref(false);

const containerWidth = ref(props.minWidth);
const dropdownWidth = ref(props.minWidth);

// 初始化显示值
const initDisplayValue = () => {
  const selectedOption = props.options.find((option) => option.value === props.modelValue);
  displayValue.value = selectedOption ? selectedOption.label : '';
  updateWidth();
};

// 更新宽度
const updateWidth = () => {
  if (inputRef.value) {
    const textWidth = getTextWidth(displayValue.value);
    const newWidth = `${Math.max(
      parseInt(props.minWidth),
      Math.min(textWidth + 40, parseInt(props.maxWidth))
    )}px`;
    containerWidth.value = newWidth;
    dropdownWidth.value = newWidth;
    containerWidth.value = '130px';
    dropdownWidth.value = '130px';
  }
};

// 获取文本宽度
const getTextWidth = (text: string) => {
  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');
  if (context) {
    context.font = getComputedStyle(inputRef.value as HTMLElement).font;
    return context.measureText(text).width;
  }
  return 0;
};

initDisplayValue();

watch(() => props.modelValue, initDisplayValue);

watch(() => props.options, initDisplayValue, { deep: true });

watch(displayValue, updateWidth);

const filteredOptions = computed(() => {
  if (!isSearching.value) {
    return props.options;
  }
  return props.options.filter((option) =>
    option.label.toLowerCase().includes(displayValue.value.toLowerCase())
  );
});

const onInput = () => {
  isSearching.value = true;
  showDropdown.value = true;
  updateWidth();
};

const onFocus = () => {
  isFocused.value = true;
  showDropdown.value = true;
};

const selectOption = (option: { label: string; value: string }) => {
  displayValue.value = option.label;
  showDropdown.value = false;
  isFocused.value = false;
  isSearching.value = false;
  emit('update:modelValue', option.value);
  emit('change', option);
  updateWidth();
};

const toggleDropdown = () => {
  if (!showDropdown.value) {
    isSearching.value = false;
    initDisplayValue();
  }
  showDropdown.value = !showDropdown.value;
  isFocused.value = showDropdown.value;
};

const closeDropdown = (event: MouseEvent) => {
  if (selectRef.value && !selectRef.value.contains(event.target as Node)) {
    showDropdown.value = false;
    isFocused.value = false;
    isSearching.value = false;
    initDisplayValue();
  }
};

onMounted(() => {
  document.addEventListener('click', closeDropdown);
  updateWidth();
});

onUnmounted(() => {
  document.removeEventListener('click', closeDropdown);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "selectRef",
    ref: selectRef,
    class: "custom-search-select",
    style: _normalizeStyle({ width: containerWidth.value })
  }, [
    _createElementVNode("div", {
      class: "select-input",
      onClick: toggleDropdown
    }, [
      _withDirectives(_createElementVNode("input", {
        ref_key: "inputRef",
        ref: inputRef,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((displayValue).value = $event)),
        placeholder: _ctx.placeholder,
        onInput: onInput,
        onFocus: onFocus,
        onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
      }, null, 40, _hoisted_1), [
        [_vModelText, displayValue.value]
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(['icon', iconClass.value])
      }, null, 2)
    ]),
    _withDirectives(_createElementVNode("div", {
      class: "select-dropdown",
      style: _normalizeStyle({ width: dropdownWidth.value })
    }, [
      (filteredOptions.value.length > 0)
        ? (_openBlock(), _createElementBlock("ul", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredOptions.value, (option) => {
              return (_openBlock(), _createElementBlock("li", {
                key: option.value,
                onClick: ($event: any) => (selectOption(option))
              }, _toDisplayString(option.label), 9, _hoisted_3))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, "No Data"))
    ], 4), [
      [_vShow, showDropdown.value]
    ])
  ], 4))
}
}

})